<template>
  <tr class="h-full">
    <td class="h-px w-0 min-w-40 py-2 pl-0">
      <div class="flex h-full w-full items-start">
        <RfBaseSkeleton height="16" width="120" dynamic />
      </div>
    </td>
    <td class="py-2">
      <div class="flex flex-col gap-1.5">
        <template v-for="i in ~~(Math.random() * 3 + 1)" :key="i">
          <RfBaseSkeleton height="16" width="182" dynamic range="80" />
        </template>
      </div>
    </td>
    <td class="w-0 py-2"></td>
  </tr>
</template>

<script setup>
import RfBaseSkeleton from "@/components/skeletons/RfBaseSkeleton.vue";
</script>
